import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19055b0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard__content-footer-buttons has-counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_button = _resolveComponent("joy-button")!
  const _component_profile_creation_step_counter = _resolveComponent("profile-creation-step-counter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showButtonPrevious)
      ? (_openBlock(), _createBlock(_component_joy_button, {
          key: 0,
          class: "profile-creation-wizard__content-footer-previous",
          variant: "secondary",
          "data-previous-step": "",
          "data-testid": _ctx.dataTestId('previous'),
          onClick: _ctx.handleClickOnPrevious
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('generic.navigation.button.prev')), 1)
          ]),
          _: 1
        }, 8, ["data-testid", "onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_profile_creation_step_counter),
    (_ctx.showButtonSkip)
      ? (_openBlock(), _createBlock(_component_joy_button, {
          key: 1,
          class: "profile-creation-wizard__step-action",
          variant: "ghost",
          "data-skip-step": "",
          "data-testid": _ctx.dataTestId('skip'),
          disabled: _ctx.isDisabledButtonSkip,
          onClick: _ctx.handleClickOnSkip
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.steps.skip')), 1)
          ]),
          _: 1
        }, 8, ["data-testid", "disabled", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.showButtonNext)
      ? (_openBlock(), _createBlock(_component_joy_button, {
          key: 2,
          class: "profile-creation-wizard__step-action push-left has-counter",
          variant: "main",
          loading: _ctx.isLoadingButtonNext,
          disabled: _ctx.isDisabledButtonNext,
          "data-testid": _ctx.dataTestId('next'),
          onClick: _ctx.handleClickOnNext
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('generic.navigation.button.next')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled", "data-testid", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.showButtonFinish)
      ? (_openBlock(), _createBlock(_component_joy_button, {
          key: 3,
          class: "profile-creation-wizard__step-action push-left has-counter",
          variant: "main",
          loading: _ctx.isLoadingButtonFinish,
          disabled: _ctx.isDisabledButtonFinish,
          "data-testid": _ctx.dataTestId('finish'),
          "data-submit-step": "",
          onClick: _ctx.handleClickOnFinish
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('profile.wizard.action.validate')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled", "data-testid", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}